import React, { useEffect, useState } from "react";
import { useSearchParams, Link } from "react-router-dom";
import { search as searchApi } from "@/lib/api";
import { TYPES, linkTo, getTitle, getBlurb, getImage } from "@/config";

export default function SearchResults() {
  const [params] = useSearchParams();
  const q = params.get("q") || "";
  const [results, setResults] = useState(null);

  useEffect(() => {
    if (!q) { setResults([]); return; }
    setResults(null);
    searchApi(q).then((d) => setResults(d.results || [])).catch(() => setResults([]));
    // searchApi/setResults are stable; effect is keyed on the query string.
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [q]);

  return (
    <div className="mx-auto max-w-[1100px] px-5 lg:px-10 py-20">
      <div className="eyebrow mb-4 text-gold">Search</div>
      <h1 className="font-serif text-4xl text-parchment lg:text-5xl">Results for “{q}”</h1>
      <div className="eyebrow mt-4">{results ? `${results.length} entries` : "Searching…"}</div>

      <div className="mt-12" data-testid="search-page-results">
        {results && results.length === 0 && (
          <p className="font-serif text-2xl text-faint">Nothing in the archive matches that query yet.</p>
        )}
        {results?.map((r) => (
          <Link key={`${r._type}-${r.id}`} to={linkTo(r._type, r.slug)} data-testid={`result-${r.slug}`}
            className="group flex gap-6 border-b border-line py-6 hover:pl-2 transition-all">
            {getImage(r) && (
              <div className="h-24 w-32 shrink-0 overflow-hidden border border-line">
                <img src={getImage(r)} alt="" className="h-full w-full object-cover grayscale-[20%]" />
              </div>
            )}
            <div className="min-w-0">
              <div className="eyebrow text-gold/70">{TYPES[r._type]?.singular}</div>
              <h3 className="font-serif text-2xl text-parchment group-hover:text-gold transition-colors">{getTitle(r)}</h3>
              <p className="mt-1 text-sm text-faint line-clamp-2">{getBlurb(r)}</p>
            </div>
          </Link>
        ))}
      </div>
    </div>
  );
}
